import React, { useContext } from "react";

import axios from "axios";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Global from "../../util/Global";
import { LoaderComponent } from "../../util/Loader";
import OrderSaleList from "../../components/OrdersSales/OrderSaleList";
import { AlertContext } from "../../util/Alerter";
import { DashboardHeaderContext } from "../../components/DashboardHeader";
import NotFound from "../../components/NotFound";

const MesCommandes = ({isAdmin}) => {
  const [isLoading, setisLoading] = useState(true)
  const { t } = useTranslation();
  const { showAlert } = useContext(AlertContext)
  const { setnavLinks, setpageTitle, setpageNavLink, setalertTitle } = useContext(DashboardHeaderContext)
  const [orders, setoreders] = useState([])

  const ORDERS_URL = Global.backend + "/index.php/api/commande/showOrders";




  useEffect(() => {
    if(isAdmin){
      setpageNavLink({ path: "/dashboard/admin", label: "adminDashboard" })
      setpageTitle("orders")
    }else{
      setpageNavLink({ path: "/dashboard", label: "navigation12.1" })
      setpageTitle("myOrders")
    }
    
    setalertTitle("")
    setnavLinks([])
  }, [])



  useEffect(() => {
    setisLoading(true)

    axios.post(ORDERS_URL)
      .then((response) => {
        setoreders(response.data)
      }).catch((err) => {
        showAlert("error", t("request.errorFetchOrders"))
      })
      .finally(() => {
        setisLoading(false);
      });
  }, []);





  return (
    <LoaderComponent isLoading={isLoading}>
      {!orders.length ? <NotFound /> : <OrderSaleList items={orders} isOrder={true} />}
    </LoaderComponent>
  )



};

export default MesCommandes;
